import { render, staticRenderFns } from "./ManagePatientAdd.vue?vue&type=template&id=89ed9e50&scoped=true&"
import script from "./ManagePatientAdd.vue?vue&type=script&lang=ts&"
export * from "./ManagePatientAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePatientAdd.vue?vue&type=style&index=0&id=89ed9e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ed9e50",
  null
  
)

export default component.exports